import { Component, Input, OnInit } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoaderComponent } from '../../layout/loader/loader.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalHeaderComponent } from '../../modals/modal-header/modal-header.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-order-product-form',
  templateUrl: './order-product-form.component.html',
  styleUrls: ['./order-product-form.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    LoaderComponent,
    ModalHeaderComponent
  ],
  standalone: true
})
export class OrderProductFormComponent implements OnInit {
  @Input() orderId: string = '';

  modalTitle: string = 'Product(en) toevoegen aan bestelling';
  modalButton: string = 'Product(en) toevoegen';
  modalStyle: boolean = true;

  errorMessage: string = '';
  loading: boolean = false;
  productList: any[] = [];
  groupedProducts: { method: string, products: any[] }[] = [];
  sortDirection: 'asc' | 'desc' = 'asc';

  search: string = "";

  constructor(private apiService: ApiService, private activeModal: NgbActiveModal, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.getProducts();
    
    if (this.route.snapshot.queryParamMap.get('popup') === 'add-products') {
      this.modalButton = 'Bestelling aanmaken'
    }
  }

  groupProductsByMethod() {
    const grouped = new Map<string, any[]>();
    
    this.productList.forEach(product => {
      const methodName = product.courses?.[0]?.title || 'Overige producten';
      if (!grouped.has(methodName)) {
        grouped.set(methodName, []);
      }
      grouped.get(methodName)?.push(product);
    });

    this.groupedProducts = Array.from(grouped.entries()).map(([method, products]) => ({
      method,
      products
    }));
    
    this.sortGroups('asc');
  }

  getProducts() {
    this.loading = true;
    this.apiService.get('/office/products?limit=500&direction=asc')
      .then((response: any) => {
        this.productList = response.data.map((product: any) => ({
          ...product,
          selected: false,
          quantity: 1,
        }));
        this.groupProductsByMethod();
        this.loading = false;
      })
      .catch(error => {
        this.loading = false;
        this.errorMessage = 'Error fetching products.';
      });
  }

  canShow(product: any) {
    const productName = product.name.toLowerCase();
    const searchLower = this.search.toLowerCase();
    return searchLower === "" || productName.includes(searchLower);
  }

  sortGroups(direction?: 'asc' | 'desc') {
    if (direction) {
      this.sortDirection = direction;
    } else {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    }

    this.groupedProducts.sort((a, b) => {
      const methodA = a.method.toLowerCase();
      const methodB = b.method.toLowerCase();

      if (this.sortDirection === 'asc') {
        return methodA.localeCompare(methodB);
      } else {
        return methodB.localeCompare(methodA);
      }
    });
  }

  addSelectedProducts() {
    const selectedProducts = this.productList.filter(product => product.selected && product.quantity > 0);

    if (selectedProducts.length === 0) {
      this.errorMessage = 'Selecteer minstens één product en geef een hoeveelheid op.';
      return;
    }

    this.loading = true;
    Promise.all(
      selectedProducts.map(product =>
        this.apiService.post(`/office/orders/${this.orderId}/items`, {
          product_id: product.id,
          quantity: product.quantity,
        })
      )
    )
      .then(() => {
        this.loading = false;
        this.activeModal.close(true);
      })
      .catch((e) => {
        this.loading = false;
        if (e.status === 422 && e.error?.error) {
          const errors = e.error.error;
          const messages = [];

          for (const field in errors) {
            if (errors[field].length) {
              messages.push(...errors[field]);
            }
          }

          this.errorMessage = messages.join(' ');
        } else {
          this.errorMessage = 'Er ging iets niet goed.';
        }
      });
  }

  activateProduct(product: any) {
    product.selected = true;
  }
}